import React from 'react'
import Popup from './Popup';
import ErrorBoundary from './ErrorBoundary';
import Table from 'react-expandable-table';
import TableScrollbar from 'react-table-scrollbar';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
var functions = require("./functions.js");
let cricutGenerateSvgLabels = require("./CricutGenerateSvgLabels.js");
// https://mybyways.com/blog/convert-svg-to-png-using-your-browser#:~:text=I%20recently%20wanted%20a%20quick,GIMP%2C%20Inkscape%20or%20LibreOffice%20Draw.

// CricutLabelPopup component
export default class CricutLabelPopup extends React.Component {

    svg = null;
    downloadFileName=null;
    maxPageLength=1600;

    // update list of inventory hubs
    componentDidUpdate(prevProps) {
        functions.sleep(1000).then(() => {this.generateNumber()});
        //this.generateNumber();
        //this.generateLabel();
    }

    // render
    render() {
        return( true) ? (
            <Popup className="move-hub-popup"  trigger={ this.props.cricutBeacons!==undefined }  >
                <div className="align-right">
                    <button className="close-btn" onClick={() => this.close() }>x</button>
                </div>
                <Tabs onSelect={index => this.selectTab(index)}>
                    <TabList>
                        <Tab>By Number</Tab>
                        <Tab>By Beacon</Tab>
                    </TabList>
                    <TabPanel>
                        <div>
                            Start Number:<input maxLength={3} defaultValue={1} className="input3Digits" id="startNumber"  onChange={this.generateNumber.bind(this)}></input>
                            Number of Label Pairs:<input maxLength={3} defaultValue={10} className="input3Digits" id="numberOfLabelPairs"  onChange={this.generateNumber.bind(this)}></input>
                            Number of Sets:<input maxLength={3} defaultValue={1} className="input3Digits" id="numberOfSets" onChange={this.generateNumber.bind(this)}></input>
                            <button onClick={()=>this.saveAsPng("numberImageDiv")}>Save As .png</button>&nbsp;
                        </div>
                        <div id="numberImageDiv" className='svg-image-div'></div>
                    </TabPanel>
                    <TabPanel>
                        <div>
                            <button onClick={()=>this.selectAll()}>Select All</button>&nbsp;
                            <button onClick={()=>this.selectNone()}>SelectNone</button>&nbsp;
                            <button onClick={()=>this.saveAsPng("beaconImageDiv")}>Save As .png</button>&nbsp;
                        </div>
                        <div className='beacon-cricut-div'>
                            <TableScrollbar height="400px">
                                <ErrorBoundary>
                                    <Table columns={[
                                        {key: 'check', title:"check", width :70, render:this.renderCheckboxInTable}
                                        , { key: 'major', title:"Major", width :30 } 
                                        , { key: 'minor', title:"Minor", width :5 }
                                        , { key: 'barcode', title:"Bar Code", width :5 }
                                    ]} 
                                    dataSource={this.props.cricutBeacons} 
                                    onRowClick={this.clickBeacon.bind(this)} 
                                    />
                                </ErrorBoundary>
                            </TableScrollbar>    
                        </div>                    
                        <div id="labelImageDiv" className='svg-image-div'></div>
                        
                    </TabPanel>
                </Tabs>
                <div>
                    Width: <input id="imageWidth" className="input3Digits"></input>&nbsp;
                    Height: <input id="imageHeight" className="input3Digits"></input>&nbsp;
                    <h3>Instructions</h3>
                    <h4>Cricut will cut away the geeen sections</h4>
                    <ol>
                        <li>Select Numbers/Labels you would like to print</li>
                        <li>Press the "Save as .png" button</li>
                        <li>Open "Cricut Design Space"</li>
                        <li>Open canvas (Menu, Canvas)</li>
                        <li>Upload png file (Upload, Upload image, browse, select file)</li>
                        <li>Select "Simple" image type, continue, Apply & Continue, Print Tnen Cut Image, Upload</li>
                        <li>Select image (select image, Add to Canvas)</li>
                        <li>Select "Make It" button</li>
                        <li>Follow instructions on the screen it will ask you to print the numbers then cut the labels</li>
                    </ol>
                </div>
                <textarea id="svgTextarea" className='hidden'></textarea>
                <div className='hidden'>
                    <canvas id="imageCanvas" ></canvas>
                </div>

            </Popup>  
        ):"";
    }
    close(){
        this.props.closeCricutLabelPopup();
    }

    generateNumber(){
        if(document.getElementById("startNumber")!=null){
            let startNumber=document.getElementById("startNumber").value;
            let numberOfLabelPairs=document.getElementById("numberOfLabelPairs").value;
            let numberOfSets=document.getElementById("numberOfSets").value;
            this.downloadFileName=`WaveNumberLabels-${startNumber}-${numberOfLabelPairs}-${numberOfSets}`
            let svgText=cricutGenerateSvgLabels.printSequence(parseInt(startNumber),parseInt(numberOfLabelPairs),parseInt(numberOfSets));
            document.getElementById("svgTextarea").innerHTML=svgText;
            let div = document.getElementById('numberImageDiv');
            div.innerHTML= svgText;
            this.svg = div.querySelector('svg');
            this.setHeightWidth();
        }
    }
    generateLabel(){
        if(document.getElementById("labelImageDiv")!=null){
            this.downloadFileName=`WaveNumberLabels`
            if(this.props.cricutBeacons.length>0){
                this.downloadFileName+="-"+this.props.cricutBeacons[0].major;
            }
            let showArr=[];
            this.props.cricutBeacons.forEach(rowData => {
                if(document.getElementById(`chk${rowData.barcode}`).value==='X'){
                    showArr.push(rowData);
                }
            });
            //let svgText=cricutGenerateSvgLabels.printSequence(1,100,1);
            let svgText=cricutGenerateSvgLabels.printFromArray(showArr);
            document.getElementById("svgTextarea").innerHTML=svgText;
            let div = document.getElementById('labelImageDiv');
            div.innerHTML= svgText;
            this.svg = div.querySelector('svg');
            this.setHeightWidth();
        }
    }
    setHeightWidth(){
        let width = document.getElementById('imageWidth');
        let height = document.getElementById('imageHeight'); 
        width.value = this.svg.getBoundingClientRect().width;
        height.value = this.svg.getBoundingClientRect().height;        
        if(this.svg.getBoundingClientRect().height>this.maxPageLength){
            height.style="background-color:red";
        } else {
            height.style="background-color:white";
        }
    }

    saveAsPng(imageDiv){

        if(this.svg != null){
            let canvas = document.getElementById('imageCanvas');
            //let div = document.getElementById(imageDiv);
            let width = document.getElementById('imageWidth');
            let height = document.getElementById('imageHeight');   
            let downloadFileName = this.downloadFileName;

            this.svg.setAttribute('width', width.value);
            this.svg.setAttribute('height', height.value);
            canvas.width = width.value;
            canvas.height = height.value;
            let data = new XMLSerializer().serializeToString(this.svg);
            let win = window.URL || window.webkitURL || window;
            let img = new Image();
            let blob = new Blob([data], { type: 'image/svg+xml' });
            let url = win.createObjectURL(blob);
            img.onload = function () {
                canvas.getContext('2d').drawImage(img, 0, 0);
                win.revokeObjectURL(url);
                let uri = canvas.toDataURL('image/png').replace('image/png', 'octet/stream');
                let a = document.createElement('a');
                document.body.appendChild(a);
                a.style = 'display: none';
                a.href = uri
                //a.download = (this.svg.id || this.svg.svg.getAttribute('name') || this.svg.getAttribute('aria-label') || 'untitled') + '.png';
                a.download =  `${downloadFileName}.png`;
                a.click();
                window.URL.revokeObjectURL(uri);
                document.body.removeChild(a);
            };
            img.src = url;        
        }
    }
    selectAll(){
        this.setAllBeaconsValue("X");    
        this.generateLabel();
    }
    selectNone(){
        this.setAllBeaconsValue("");    
        this.generateLabel();
    }    
    // display a checkbox
    renderCheckboxInTable(cellData, rowData, rowIndex){
        var x = React.createElement("INPUT",{ type: 'text', id:`chk${rowData.barcode}`, value:`X`, className:"cricutCheckboxInput"});
        //x.type="checkbox";
        return x; 
    }
    clickBeacon( rowData, rowIndex ){
        let obj=document.getElementById(`chk${rowData.barcode}`);
        if(obj.value==='X'){
            obj.value=''
        } else {
            obj.value='X'
        }
        this.generateLabel();
    }
    setAllBeaconsValue(val){
        this.props.cricutBeacons.forEach(rowData => {
            document.getElementById(`chk${rowData.barcode}`).value=val;
        });        
    }
    selectTab(index){
        if(index===0){
            functions.sleep(1000).then(() => {this.generateNumber()});
        } else {
            functions.sleep(1000).then(() => {this.generateLabel()});            
        }
    }
}

